import Component from '@bythepixel/component-loader';

export default class Tinymce extends Component {
  static selector = '[data-comp-tinymce]';

  constructor(containerEl) {
    super(containerEl);
    this.iframes = this.$container.querySelectorAll('iframe');
    this.facebookVideos = [];
    this.videos = [];

    this.determineIframes();
    this.addWrapperDivsToVideos();
    this.addWrapperDivsToFacebookVideoIframes();
  }

  /**
   * Facebook iframes with videos will be styled similarly to videos in mobile
   * Some extra calculations need to be done to account for different post sizes
   */
  addWrapperDivsToFacebookVideoIframes() {
    if (this.facebookVideos.length > 0) {
      this.facebookVideos.forEach(video => {
        const height = video.getAttribute('height');
        const width = video.getAttribute('width');
        let ratio = height / width;

        // Only in mobile
        if (window.matchMedia('(max-width: 479px)').matches) {
          // Create wrapper div and add responsive styling
          const wrapperDiv = document.createElement('div');
          wrapperDiv.classList.add('video-wrapper');

          if (ratio === 1) {
            wrapperDiv.style.paddingBottom = '100%';
          } else {
            // eslint-disable-next-line no-restricted-properties
            ratio /= (10 ** (-2));
            wrapperDiv.style.paddingBottom = `${Math.ceil(ratio) + 25}%`;
          }

          // Insert wrapper div before the video
          video.parentNode.insertBefore(wrapperDiv, video);

          // Move the video into the wrapper div
          wrapperDiv.appendChild(video);
        }
      });
    }
  }

  /**
   * When a video is inserted into the Tinymce editor, the video styling is not responsive and is restricted to dimensions
   * Unfortunately, there is no built-in functionality for Tinymce to add a wrapper div to videos
   * This is a workaround
   */
  addWrapperDivsToVideos() {
    if (this.videos.length > 0) {
      this.videos.forEach(video => {
        // Create wrapper div and add responsive styling
        const wrapperDiv = document.createElement('div');
        wrapperDiv.classList.add('video-wrapper');

        // Insert wrapper div before the video
        video.parentNode.insertBefore(wrapperDiv, video);

        // Move the video into the wrapper div
        wrapperDiv.appendChild(video);
      });
    }
  }

  /**
   * If an iframe contains a youtube or vimeo link, it is a video and needs to be styled as one
   * If an iframe contains a facebook link with a video, it needs to be styled similarly to videos with a couple of differences
   * Otherwise, leave it alone
   */
  determineIframes() {
    if (this.iframes.length > 0) {
      this.iframes.forEach(iframe => {
        const { src } = iframe.dataset;
        if (src && (src.includes('youtube') || src.includes('vimeo'))) {
          this.videos.push(iframe);
        } else if (src && (src.includes('facebook') && src.includes('video'))) {
          this.facebookVideos.push(iframe);
        }
      });
    }
  }
}
